import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("ce_cookie_consent")) {
      const t = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  function decide(value) {
    localStorage.setItem("ce_cookie_consent", value);
    setShow(false);
  }

  if (!show) return null;
  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-50 rounded-2xl bg-white shadow-2xl border border-border p-5"
      data-testid="cookie-banner"
    >
      <button
        onClick={() => setShow(false)}
        aria-label="Sluiten"
        className="absolute top-3 right-3 text-ink-soft hover:text-ink"
      >
        <X className="h-4 w-4" />
      </button>
      <h4 className="font-display text-base font-semibold text-ink">We respecteren je privacy</h4>
      <p className="text-sm text-ink-soft mt-2 leading-relaxed">
        We gebruiken alleen functionele cookies en anonieme statistieken. Lees ons{" "}
        <Link to="/cookiebeleid" className="text-[#002FA7] font-semibold underline">
          cookiebeleid
        </Link>
        .
      </p>
      <div className="flex gap-2 mt-4">
        <button
          onClick={() => decide("all")}
          className="flex-1 px-4 py-2 rounded-full bg-[#002FA7] hover:bg-[#0033B5] text-white text-sm font-semibold"
          data-testid="cookie-accept-all"
        >
          Alles accepteren
        </button>
        <button
          onClick={() => decide("essential")}
          className="flex-1 px-4 py-2 rounded-full bg-white border border-border text-ink text-sm font-semibold hover:border-ink-soft"
          data-testid="cookie-essential"
        >
          Enkel noodzakelijk
        </button>
      </div>
    </div>
  );
}
